// extracted by mini-css-extract-plugin
export var dateLabel = "_32-0";
export var dateLabelError = "_32-1";
export var fullWidth = "_32-2";
export var smaller = "_32-3";